let baseUrl = ''

export const setBaseUrl = (next: string) => {
    baseUrl = next
}

export const getBaseUrl = () => baseUrl
